import React, { FC, useEffect, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Button, ListItemText, MenuList } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import TranslateIcon from '@mui/icons-material/Translate';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { languages } from '@/features/language-switcher/config';
import { useCookies } from 'react-cookie';

export const LanguageSwitcher: FC<{
  dark?: boolean;
}> = ({ dark }) => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [cookies, setCookie] = useCookies(['hl']);

  useEffect(() => {
    if (cookies.hl) {
      i18n.changeLanguage(cookies.hl);
    } else {
      setCookie('hl', 'en');
    }
  }, [cookies]);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSwitchLanguage = (code: string) => () => {
    setCookie('hl', code);
    i18n.changeLanguage(code);
    handleClose();
  };

  const currentLanguage = languages.find((item) => item.code === cookies.hl);

  return (
    <div>
      {currentLanguage && (
        <Button
          onClick={handleClick}
          endIcon={<KeyboardArrowDownIcon />}
          startIcon={<TranslateIcon />}
          disableElevation={true}
          sx={dark ? { borderColor: 'white', color: 'white' } : {}}
        >
          <Trans i18nKey={currentLanguage.label} />
        </Button>
      )}

      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuList sx={{ width: 150, maxWidth: '100%' }}>
          {languages.map((item) => (
            <MenuItem
              key={item.label}
              onClick={handleSwitchLanguage(item.code)}
            >
              <ListItemText>{t(item.label)}</ListItemText>
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </div>
  );
};
